import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {
    isLoggedIn: false,
    user: null,
    navMenuItems: [],
  },
  getters: {
    getLoggedInUser: (state) => {
      return state.user;
    },
    hasPermission: (state) => (name) => {
      if (state.user) {
        return state.user.permissions.hasOwnProperty(name);
      }
      return false;
    },
    hasRole: (state) => (name) => {
      if (state.user.role_data.code_name === name) {
        return true;
      }
      return false;
    },
    isLoggedIn: (state) => state.isLoggedIn,
    getNavMenuItems: (state) => state.navMenuItems,
  },
  mutations: {
    login(state, data) {
      state.isLoggedIn = true;
      state.user = data.user;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.user = null;
    },
    setNavMenuItems(state) {
      state.navMenuItems = [];
      if (state.user.permissions.hasOwnProperty("show_dashboard")) {
        state.navMenuItems.push({
          title: "Dashboard",
          icon: "BarChartIcon",
          route: "Dashboard",
        });
      }

      
      if (state.user.permissions.hasOwnProperty("show_role")) {
        state.navMenuItems.push({
          title: "Roles",
          icon: "SlidersIcon",
          route: "Role",
        });
      }


      if (state.user.permissions.hasOwnProperty("show_user")) {
        state.navMenuItems.push({
          title: "Users",
          icon: "UsersIcon",
          route: "User",
        });
      }


      if (state.user.permissions.hasOwnProperty("show_customer")) {      
        state.navMenuItems.push({
          title: "Customers",
          icon: "DatabaseIcon",
          route: "Customer",
        });
      }

      state.navMenuItems.push({
        title: "Leads",
        icon: "MonitorIcon",
        route: "Lead",
      });
      
      if (state.user.permissions.hasOwnProperty("show_campaign")) {
        state.navMenuItems.push({
          title: "Campaign",
          icon: "PhoneCallIcon",
          route: "Campaign",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_subscription_plan")) {      
        state.navMenuItems.push({
          title: "Subscription Plans",
          icon: "RssIcon",
          route: "SubscriptionPlan",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_agent_subscription")) {
        state.navMenuItems.push({
          title: "Agent Subscriptions",
          icon: "UserCheckIcon",
          route: "AgentSubscription",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_ai_call_log")) {
        state.navMenuItems.push({
          title: "Ai Call Logs",
          icon: "PhoneForwardedIcon",
          route: "AICallLog",
        });
      }

      if (state.user.permissions.hasOwnProperty("show_state")) {
        state.navMenuItems.push({
          title: "States",
          icon: "HomeIcon",
          route: "State",
        });
      }
      
      
    },
  },
  actions: {
    async login({ commit }, payload) {
      const res = await axiosIns.post("login", payload);
      if (res.status === 200) {
        commit("login", res.data);
        commit("setNavMenuItems");
      }
      return res;
    },

    async mobileLogin({ commit }, payload) {
      const res = await axiosIns.post("mobile_login", payload);      
      return res;
    },

    async logout({ commit }) {
      const res = await axiosIns.post("logout");
      if (res.status === 204) {
        commit("logout");
      }
      return res;
    },
    async getCurrentUser({ commit }) {
      const res = await axiosIns.get("current");
      if (res.status === 200) {
        commit("login", res.data);
        commit("setNavMenuItems");
      }
    },
    async getRoles({ commit }, { pageNumber, name }) {
      let url = `roles/?page=${pageNumber}`;
      if (name) {
        url += `&name=${name}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },
    async getRolesDDL({ commit }) {
      let url = `roles/?page=1`;      
      const res = await axiosIns.get(url);
      return res;
    },
    async getRole({ commit }, { pk }) {
      const res = await axiosIns.get(`roles/${pk}/`);
      return res;
    },
    async createRole({ commit }, payload) {
      const res = await axiosIns.post("roles/", payload);
      return res;
    },
    async updateRole({ commit }, { payload, pk }) {
      const res = await axiosIns.put(`roles/${pk}/`, payload);
      return res;
    },
    async deleteRole({ commit }, { pk }) {
      const res = await axiosIns.delete(`roles/${pk}/`);
      return res;
    },
    async getPermissions({ commit }) {
      const res = await axiosIns.get("permissions");
      return res;
    },
    async getUsers({ commit }, { pageNumber, name, username, role, email }) {
      let url = `users/?page=${pageNumber}`;
      if (name) {
        url += `&name=${name}`;
      }
      if (username) {
        url += `&username=${username}`;
      }
      
      if (role) {
        url += `&role=${role.code_name}`;
      }


      if (email) {
        url += `&email=${email}`;
      }
      const res = await axiosIns.get(url);
      return res;
    },
    async getUsersDDL({ commit }) {
      let url = `users_list/`;      
      const res = await axiosIns.get(url);
      return res;
    },
    async getUser({ commit }, { pk }) {
      const res = await axiosIns.get(`users/${pk}/`);
      return res;
    },
    async createUser({ commit }, payload) {
      const res = await axiosIns.post("users/", payload);
      return res;
    },
    async updateUser({ commit }, { payload, pk }) {
      const res = await axiosIns.patch(`users/${pk}/`, payload);
      return res;
    },
    async approveUser({ commit }, { pk }) {
      const res = await axiosIns.patch(`users/${pk}/`, {
        eligibility_status: "approved",
        is_active: true,
      });
      return res;
    },
    async deleteUser({ commit }, { pk }) {
      const res = await axiosIns.delete(`users/${pk}/`);
      return res;
    },


    async getStates({ commit }, payload) {
      const res = await axiosIns.get("/states/", { params: payload });
      return res;
    },
    async createState({ commit }, payload) {
      const res = await axiosIns.post("/states/", payload);
      return res;
    },
    async updateState({ commit }, { pk, payload }) {
      const res = await axiosIns.put(`/states/${pk}/`, payload);
      return res;
    },
    async deleteState({ commit }, { pk }) {
      const res = await axiosIns.delete(`/states/${pk}/`);
      return res;
    },

    // ================= CUSTOMERS =================
    async getCustomers({ commit }, payload) {
      const res = await axiosIns.get("/customers/", { params: payload });
      return res;
    },
    async createCustomer({ commit }, payload) {
      const res = await axiosIns.post("/customers/", payload);
      return res;
    },
    async updateCustomer({ commit }, { pk, payload }) {
      const res = await axiosIns.put(`/customers/${pk}/`, payload);
      return res;
    },
    async deleteCustomer({ commit }, { pk }) {
      const res = await axiosIns.delete(`/customers/${pk}/`);
      return res;
    },
    async bulkUploadCustomers({ commit }, payload) {
      const res = await axiosIns.post("/customers/bulk-upload/", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res;
    },
    async downloadSampleCsv({ commit }) {
      const res = await axiosIns.get("/customers/sample-excel/", {
        responseType: "blob",
      });
      return res;
    },

    // ================= LEADS =================
    async getLeads({ commit }, payload) {
      const res = await axiosIns.get("/leads/", { params: payload });
      return res;
    },
     async createLead({ commit }, payload) {
      const res = await axiosIns.post("/leads/", payload);
      return res;
    },
    async updateLead({ commit }, { pk, payload }) {
      const res = await axiosIns.put(`/leads/${pk}/`, payload);
      return res;
    },

    // ================= AGENTS =================
    async getAgents({ commit }, payload) {
      const res = await axiosIns.get("/agents/", { params: payload });
      return res;
    },
    async createAgent({ commit }, payload) {
      const res = await axiosIns.post("/agents/", payload);
      return res;
    },
    async updateAgent({ commit }, { pk, payload }) {
      const res = await axiosIns.put(`/agents/${pk}/`, payload);
      return res;
    },

    // ================= SUBSCRIPTION =================
    async getSubscriptionPlans({ commit }, payload) {
      const res = await axiosIns.get("/subscription-plans/", { params: payload });
      return res;
    },
    async createSubscriptionPlan({ commit }, payload) {
      const res = await axiosIns.post("/subscription-plans/", payload);
      return res;
    },
    async updateSubscriptionPlan({ commit }, { pk, payload }) {
      const res = await axiosIns.put(`/subscription-plans/${pk}/`, payload);
      return res;
    },

    // ================= AGENT SUBSCRIPTIONS =================
    async getAgentSubscriptions({ commit }, params) {
      const res = await axiosIns.get("/agent-subscriptions/", { params });
      return res;
    },
    async createAgentSubscription({ commit }, payload) {
      const res = await axiosIns.post("/agent-subscriptions/", payload);
      return res;
    },
    async updateAgentSubscription({ commit }, { pk, payload }) {
      const res = await axiosIns.put(`/agent-subscriptions/${pk}/`, payload);
      return res;
    },

    // ================= AI CALL LOGS =================
    async getAICallLogs({ commit }, params) {
      const res = await axiosIns.get("/ai-call-logs/", { params });
      return res;
    },

    async createAICallLog({ commit }, payload) {
      const res = await axiosIns.post("/ai-call-logs/", payload);
      return res;
    },

    async updateAICallLog({ commit }, { pk, payload }) {
      const res = await axiosIns.put(`/ai-call-logs/${pk}/`, payload);
      return res;
    },

    async changePassword({ commit }, { payload }) {
      const res = await axiosIns.post(`users/change-password/`, payload);
      return res;
    },
    async requestReset({ commit }, { payload }) {
      const res = await axiosIns.post(`password-reset/request-reset/`, payload);
      return res;
    },
    async confirmReset({ commit }, { payload }) {
      const res = await axiosIns.post(`password-reset/confirm-reset/`, payload);
      return res;
    },
    async checkResetCode({ commit }, { payload }) {
      const res = await axiosIns.post(`password-reset/check-reset-code/`, payload);
      return res;
    },

    async createSignup({ commit }, payload) {
      const res = await axiosIns.post("signup", payload);
      return res;
    },

    async uploadClientList({ commit }, payload) {
      const res = await axiosIns.post("upload-clients/", payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res;
    },

    // ================= CAMPAIGN =================
    async getCampaignData({ commit }, params) {
      const res = await axiosIns.get("/campaigns/results/", { params });
      return res;
    },

    async startCampaign({ commit }) {
      const res = await axiosIns.post("/campaigns/start_campaign/");
      return res;
    },

    async exportCampaignData({ commit }, params) {
      const res = await axiosIns.get("/campaigns/export/", { 
        params,
        responseType: 'blob',
      });
      return res;
    },

    async updateCampaignNotes({ commit }, { id, notes }) {
      const res = await axiosIns.patch(`/campaigns/update_notes/${id}/`, { notes });
      return res;
    },

    async getCampaignStats({ commit }) {
      const res = await axiosIns.get("/campaign/stats/");
      return res;
    },

    // ================= ADMIN DASHBOARD =================
    async getAdminDashboardStats({ commit }, params) {
      const res = await axiosIns.get("/api/admin-dashboard/stats/", { params });
      return res;
    },

    // ================= AGENT DASHBOARD =================
    async getAgentDashboardStats({ commit }) {
      const res = await axiosIns.get("/agent-dashboard/stats/");
      return res;
    },

    async getAgentRecommendedLeads({ commit }, params) {
      const res = await axiosIns.get("/agent-dashboard/recommended_leads/", { params });
      return res;
    },

    async getAgentUpcomingFollowups({ commit }) {
      const res = await axiosIns.get("/agent-dashboard/upcoming_followups/");
      return res;
    },

  },
};
